import { SnCurrentOrganization } from '@lib/auth';
import { FUSUS_CROSS_REGION_DEV } from 'libs/share/src/lib/constants';

export function shouldEnableCursorPagination(currentOrg: SnCurrentOrganization): boolean {
  return currentOrg.settings[FUSUS_CROSS_REGION_DEV] === true;
}
